import { lazy, Suspense } from 'react';

import './config/style.scss';

import { config, providers as CommonProviders } from '@febos-io/common';
import './config/packagesI18nConfig';
import './config/packagesIcons';
import configureReducers from './config/configureReducers';
import sagasConfig from './config/sagasConfig';

import MuiBoostrap from './pages/companies/setting/MuiBoostrap';

const App = lazy(() => import('./App'));

const store = config.configureStore(configureReducers(), {
  persistConfig: {},
  sagas: sagasConfig,
});

export function Bootstrap() {
  return (
    <CommonProviders.AppContextProvider store={store}>
      <MuiBoostrap>
        <Suspense>
          <App />
        </Suspense>
      </MuiBoostrap>
    </CommonProviders.AppContextProvider>
  );
}

export default Bootstrap;
